import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { PermissionGuard } from '../guards/permission.guard';
import { lazyRoute, lazyRouteNamed } from '../lazy-route';

const equipmentPageRoute = lazyRoute(() => import('../../pages/equipment/EquipmentPage'));

export const haccpRoutes: RouteObject[] = [
  {
    path: RoutesList.HOME,
    element: <MainLayout />,
    children: [{ index: true, ...lazyRoute(() => import('../../pages/Home')) }],
  },
  {
    path: RoutesList.HACCP,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRoute(() => import('../../pages/haccp-dashboard/HaccpDashboardPage')),
      },
      {
        path: 'audit-dossier',
        ...lazyRouteNamed(
          () => import('../../pages/haccp-dashboard/audit-dossier-page'),
          'AuditDossierPage',
        ),
      },
      {
        path: 'andamento',
        ...lazyRoute(() => import('../../pages/haccp-dashboard/tenant-stats-page')),
      },
    ],
  },
  {
    path: RoutesList.EQUIPMENT,
    element: <MainLayout />,
    children: [
      { index: true, ...equipmentPageRoute },
      {
        path: 'ambient-registry',
        ...lazyRoute(() => import('../../pages/ambient-registry/ambient-registry-page')),
      },
      {
        path: 'ambient-registry/export',
        ...lazyRoute(() => import('../../pages/ambient-registry/ambient-registry-export-page')),
      },
      { path: 'refrigerators/new', ...equipmentPageRoute },
      { path: 'refrigerators/:id/edit', ...equipmentPageRoute },
      { path: 'hot-holding/new', ...equipmentPageRoute },
      { path: 'hot-holding/:id/edit', ...equipmentPageRoute },
      { path: 'fryers/new', ...equipmentPageRoute },
      { path: 'fryers/:id/edit', ...equipmentPageRoute },
      { path: 'pest-control/new', ...equipmentPageRoute },
      { path: 'pest-control/:id/edit', ...equipmentPageRoute },
      { path: 'metal-detection/new', ...equipmentPageRoute },
      { path: 'metal-detection/:id/edit', ...equipmentPageRoute },
    ],
  },
  {
    path: RoutesList.CLEANING_AREAS,
    element: <MainLayout />,
    children: [
      { index: true, ...lazyRoute(() => import('../../pages/cleaning-areas/main-page')) },
      { path: 'new', ...lazyRoute(() => import('../../pages/cleaning-areas/main-page')) },
      { path: ':id/edit', ...lazyRoute(() => import('../../pages/cleaning-areas/main-page')) },
    ],
  },
  {
    path: RoutesList.INSPECTION_ACCESS,
    element: <PermissionGuard permission="INSPECTION_ACCESS" redirectTo={RoutesList.HACCP} />,
    children: [
      {
        path: '',
        element: <MainLayout />,
        children: [
          {
            index: true,
            ...lazyRouteNamed(
              () => import('../../pages/inspection-access/inspection-access-page'),
              'InspectionAccessPage',
            ),
          },
        ],
      },
    ],
  },
];
